import { ApiServerClient } from '../store/Api.js'
export default {
  state: {
    test: true,
    userAuthenticated: false,
    userName: '',
    darkMode: false,
    accessibilityMode: false,
    deploymentCode: '',
    corruptedUserData: false
  },
  mutations: {
    UPDATE_TEST (state, data) {
      state.test = data
    },
    UPDATE_AUTH_STATUS (state, payload) {
      state.userAuthenticated = payload.userAuthenticated
      state.userName = payload.userName
      state.deploymentCode = payload.deploymentCode
    },
    updateDarkTheme (state, val) {
      state.darkMode = val
    },
    updateAccessibilityMode (state, val) {
      state.accessibilityMode = val
    },
    UPDATE_USER_DATA_MISMATCH (state, val) {
      state.corruptedUserData = val
    }
  },
  actions: {
    updateTest ({ commit }, data) {
      commit('UPDATE_TEST', data)
    },
    async login ({ commit }) {
      const url = '/UnifiedHome/Login'
      const response = await ApiServerClient.get(url, { returnUrl: `${process.env.VUE_APP_SELF_URL}/home/login` })
      return response.Data
    },
    async logout ({ commit }) {
      const url = '/UnifiedHome/Logout'
      const response = await ApiServerClient.get(url, { returnUrl: `${process.env.VUE_APP_SELF_URL}/home` })
      return response.Data
    },
    async getUserAuthStatus ({ dispatch, commit }) {
      const url = '/UnifiedHome/UserAuthStatus'
      try {
        const response = await ApiServerClient.get(url)
        commit('UPDATE_AUTH_STATUS', response.Data)
        commit('Header/SET_HEADER_USERNAME', response.Data.userName, { root: true })
      } catch (ex) {
        if (ex.code === 429) {
          await dispatch('getUserAuthStatus')
        }
        commit('UPDATE_USER_DATA_MISMATCH', true)
      }
    },
    toggleDarkMode ({ commit }, val) {
      commit('updateDarkTheme', val)
      commit('updateAccessibilityMode', false)
    },
    toggleAccessibilityMode ({ commit }, val) {
      commit('updateDarkTheme', false)
      commit('updateAccessibilityMode', val)
    },
    eraseCorruptedUserData ({ commit }) {
      commit('UPDATE_USER_DATA_MISMATCH', false)
    }
  },
  getters: {
    darkModeState (state) {
      return state.darkMode
    },
    accessibilityModeState (state) {
      return state.accessibilityMode
    }
  }
}
